import * as React from 'react';

import { dispatchNotinoEvent } from '@utils/notino-events';

interface Options {
  section: string;
}

const EMPTY: Partial<Options> = {
  section: undefined,
};

export const dispatchProductsShownEvent = (
  products:
    | Array<{
        webId: number | string;
        attributes?: { Pharmacy?: boolean };
      } | null>
    | null
    | undefined,
  options: Partial<Options> = EMPTY
) => {
  if (products && Array.isArray(products)) {
    dispatchNotinoEvent({
      name: 'products:shown',
      payload: {
        section: options.section,
        products: products
          .filter((p): p is NonNullable<typeof p> => p != null)
          .map((product) => ({
            id: String(product.webId),
            isPharmacy: Boolean(product.attributes?.Pharmacy),
          })),
      },
    });
  }
};

export const useDispatchProductsShowEvent = (
  products: Array<{
    webId: number | string;
    attributes?: { Pharmacy: boolean };
  }>,
  options: Partial<Options> = EMPTY
) => {
  const { section } = options;
  React.useEffect(() => {
    dispatchProductsShownEvent(products, { section });
  }, [products, section]);
};
